import { Box } from "@mui/material";
import { ColDefWithTab } from "@pages/Assets/common/FilterColumn/context";
import Typography from "@common/components/Typography";
import { FormLabel } from "@mui/material";
import { SimpleEntry } from "@services/catalog/types";
import Select from "@common/components/Select";
import MenuItem from "@common/components/MenuItem";
import DebouncedTextField from "@common/components/DebouncedTextField";
import { TFunction } from "react-i18next";

export interface MappingEntryWithIndex extends SimpleEntry {
  index: number;
}

export const properties = [
  {
    field: "thirdPartyId",
    label: "3rd Party ID",
  },
  {
    field: "externalId",
    label: "Configuration Item ID",
  },
  {
    field: "customerCostCenterId",
    label: "Customer Cost Center ID",
  },
  {
    field: "e164",
    label: "E.164",
  },
  {
    field: "gatekeeperIp",
    label: "Gatekeeper IP",
  },
  {
    field: "details.h323Id",
    label: "H.323 ID",
  },
  {
    field: "ipAddress",
    label: "IP Address",
  },
  {
    field: "localIpAddress",
    label: "Local IP Address",
  },
  {
    field: "macAddress",
    label: "MAC Address",
  },
  {
    field: "details.managementUrl",
    label: "Management URL",
  },
  {
    field: "msTeamsId",
    label: "MS Team ID",
  },
  {
    field: "name",
    label: "Name",
  },
  {
    field: "operatingSystem",
    label: "Operating System",
  },
  {
    field: "protocol",
    label: "Protocol",
  },
  {
    field: "serialNumber",
    label: "Serial Number",
  },
  {
    field: "sipRegistrar",
    label: "SIP Registrar",
  },
  {
    field: "sipUri",
    label: "SIP URI",
  },
  {
    field: "softwareVersion",
    label: "Software Version",
  },
  {
    field: "ucPlatform",
    label: "UC Platform",
  },
];

export const getColumns = (
  canEdit: boolean,
  t: TFunction<"translation", undefined>,
  isCustom: boolean,
  handleFieldChange: (row: MappingEntryWithIndex) => void,
  handleExtendedPropertyChange: (row: MappingEntryWithIndex) => void,
  excludedproperties: string[],
  setDataChangeFlag: () => void
): ColDefWithTab<MappingEntryWithIndex>[] => {
  return [
    {
      key: "index",
      label: "index",
      show: false,
    },
    {
      key: "name",
      label: "Field",
      sortable: true,
      renderHeader: () => <FormLabel required>{t("Field")}</FormLabel>,

      render: (row) => (
        <Box sx={{ width: "100%", marginRight: 1.5 }}>
          {isCustom ? (
            <Select
              disabled={!canEdit}
              value={row.name}
              variant="outlined"
              onChange={(evt) =>
                handleFieldChange({
                  ...row,
                  name: `${evt.target.value}`,
                })
              }
            >
              {properties
                .filter(
                  (f) =>
                    !excludedproperties.includes(f.field) || row.name == f.field
                )
                .map((v) => (
                  <MenuItem key={v.field} value={v.field}>
                    {v.label}
                  </MenuItem>
                ))}
            </Select>
          ) : (
            <Typography size="small" textAlign="left" sx={{ width: "100%" }}>
              {properties.find((p) => p.field == row.name)?.label}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      key: "value",
      label: "Extended Property Name",
      renderHeader: () => (
        <FormLabel required>{t("Extended Property Name")}</FormLabel>
      ),

      sortable: true,
      render: (row) => (
        <>
          {isCustom ? (
            <DebouncedTextField
              disabled={!canEdit}
              value={row.value}
              fullWidth
              name="oid"
              variant="outlined"
              immediateCallback={setDataChangeFlag}
              onChange={(value) =>
                handleExtendedPropertyChange({
                  ...row,
                  value: value,
                })
              }
            />
          ) : (
            <Typography size="small" textAlign="left" sx={{ width: "100%" }}>
              {row.value}
            </Typography>
          )}
        </>
      ),
    },
  ];
};
